import { render, staticRenderFns } from "./MyPrizePopup.vue?vue&type=template&id=6edf0152&scoped=true"
import script from "./MyPrizePopup.vue?vue&type=script&lang=ts"
export * from "./MyPrizePopup.vue?vue&type=script&lang=ts"
import style0 from "./MyPrizePopup.vue?vue&type=style&index=0&id=6edf0152&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edf0152",
  null
  
)

export default component.exports